import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginModel } from '../model/login.model';
import { LocalStorageService } from '../services/localstorage.service';
import { SnackBarService } from '../services/snack-bar-service.service';
import { IConsultaSubFrotaModel, IConsultaVeiculoSubFrotaModel, IFiltroSubFrotaModel, IRetornoSubFrotaModel, ISubFrotaModel } from './model/subFrota.model';
import {IRelatorioExtratoCartao, RelatorioExtratoCartao} from './model/relatorio-extrato-cartao';
import {subscribeToArray} from "rxjs/internal/util/subscribeToArray";
import { FiltroAbastecimentosViewModel } from './model/filtro-abastecimentos-view-model';
import { IFiltroTransacoesViewModel } from '../relatorios/model/filtro-transacoes-view-model';
import {
  AbastecimentosViewModel,
  AbastecimentosViewModelEditado, IAbastecimentoEditadoResponse, IAbastecimentosViewModel, ITransacoes
} from './model/abastecimentos-view-model';
import {INomeCombustivel, NomeCombustivel} from "../precos-combustiveis/model/AlteracaoCombustivel";
import {AbastecimentoPutModel} from "./model/abastecimento-put-model";
import {AbastecimentosViewModelEditadoResult} from "./model/abastecimentos-view-model-editado-result";
import {AprovacaoCorrecaoKm, AprovacaoCorrecaoKmResult} from "./model/aprovacao-correcao-km";
import {IContatoResponse} from "./model/contato";
import { IFiltroSubfrotaModel } from '../frota/model/frota.model';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Injectable({
  providedIn: 'root'
})
export class SubfrotaService {
  private ufs = [
    { codigo: '1', sigla: 'AC' },
    { codigo: '2', sigla: 'AL' },
    { codigo: '3', sigla: 'AM' },
    { codigo: '4', sigla: 'AP' },
    { codigo: '5', sigla: 'BA' },
    { codigo: '6', sigla: 'CE' },
    { codigo: '7', sigla: 'DF' },
    { codigo: '8', sigla: 'ES' },
    { codigo: '10', sigla: 'GO' },
    { codigo: '11', sigla: 'MA' },
    { codigo: '14', sigla: 'MG' },
    { codigo: '13', sigla: 'MS' },
    { codigo: '12', sigla: 'MT' },
    { codigo: '15', sigla: 'PA' },
    { codigo: '16', sigla: 'PB' },
    { codigo: '18', sigla: 'PE' },
    { codigo: '19', sigla: 'PI' },
    { codigo: '17', sigla: 'PR' },
    { codigo: '20', sigla: 'RJ' },
    { codigo: '21', sigla: 'RN' },
    { codigo: '23', sigla: 'RO' },
    { codigo: '9', sigla: 'RR' },
    { codigo: '22', sigla: 'RS' },
    { codigo: '25', sigla: 'SC' },
    { codigo: '27', sigla: 'SE' },
    { codigo: '26', sigla: 'SP' },
    { codigo: '24', sigla: 'TO' },
  ];

  public usuario!: LoginModel;

  public codigoSubFrota!: number;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private localStorageService: LocalStorageService,
    private snackBar: SnackBarService) {

    var userData = this.localStorageService.getItem('userData');

    if (userData != null) {
      this.usuario = JSON.parse(userData);
    }
  }

  returnAllUfs() {
    return this.ufs;
  }

  getSubFrotas(filtro: IFiltroSubFrotaModel): Observable<IConsultaSubFrotaModel> {

    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ConsultaSubFrota;

    return this.http.post<IConsultaSubFrotaModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar as SubFrotas.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IConsultaSubFrotaModel>('Não foi possível consultar as SubFrotas.', {sucesso : false, retorno: [], mensagens: []}))
    );
  }

  getListaContatos(userGuid: string): Observable<IContatoResponse>{

    const url = environment.host_ctf_service+CONFIG_URLS_API.API_ListaContatos + '/pegarListaContatos';

    return  this.http.post<IContatoResponse>(url, {guid: userGuid}).pipe(
      tap(response => {
        // console.log(response)
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível obter a lista de contatos.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IContatoResponse>('Não foi possível obter a lista de contatos.',  {sucesso : false, retorno: [], mensagens: []}))
    );
  }

  listSubFrotas(filtro: IFiltroSubFrotaModel): Observable<IConsultaSubFrotaModel> {

    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ListaSubFrota;

    return this.http.post<IConsultaSubFrotaModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar as SubFrotas.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IConsultaSubFrotaModel>('Não foi possível consultar as SubFrotas.', {sucesso : false, retorno: [], mensagens: []}))
    );
  }

  obter(filtro: IFiltroSubFrotaModel): Observable<IRetornoSubFrotaModel> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ObterSubFrota;

    return this.http.post<IRetornoSubFrotaModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível obter a SubFrota.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IRetornoSubFrotaModel>('Não foi possível obter a SubFrota.', {sucesso : false, retorno: {enderecos: []}, mensagens: []}))
    );

  }

  listFrotaParametro(filtro: IFiltroSubfrotaModel): Observable<IConsultaSubFrotaModel>{

    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_BuscaSubfrota;

    return this.http.post<IConsultaSubFrotaModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar as Subfrotas.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IConsultaSubFrotaModel>('Não foi possível consultar as Subfrotas.', {sucesso : false, retorno: [], mensagens: []}))
    );
  }

  incluir(subFrota: ISubFrotaModel): Observable<IRetornoSubFrotaModel> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_IncluirSubFrota;

    return this.http.post<IRetornoSubFrotaModel>(url, subFrota, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível incluir a SubFrota.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IRetornoSubFrotaModel>('Não foi possível incluir a SubFrota.', {sucesso : false, retorno: {enderecos: []}, mensagens: []}))
    );
  }

  getListaCombustiveis(guid: string): Observable<INomeCombustivel>{

    // console.log(guid)


    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ConsultaListaCombustiveis + guid;

    return this.http.get<INomeCombustivel>(url).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar as SubFrotas.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<INomeCombustivel>('Não foi possível consultar as SubFrotas.', {sucesso : false, retorno: [], mensagens: []}))
    );
  }


  alterar(subFrota: ISubFrotaModel): Observable<IRetornoSubFrotaModel> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_AlterarSubFrota;

    return this.http.post<IRetornoSubFrotaModel>(url, subFrota, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível alterar a SubFrota.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IRetornoSubFrotaModel>('Não foi possível alterar a SubFrota.', {sucesso : false, retorno: {enderecos: []}, mensagens: []}))
    );
  }

  excluir(subFrota: ISubFrotaModel): Observable<IRetornoSubFrotaModel> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ExcluirSubFrota;

    return this.http.post<IRetornoSubFrotaModel>(url, subFrota, this.httpOptions);
  }
/*
  obterListaRelatorioExtratoCartaoAbastecimento(): Observable<IRelatorioExtratoCartao>{
    //const url = environment.host_ctf_service+ environment.API_ListaRelatorioExtratoCartaoAbastecimento;

    const url = '  http://localhost:3000/listaRelatorioExtratoCartaoAbastecimento';

    return this.http.post<IRelatorioExtratoCartao>(url, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível obter a SubFrota.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IRelatorioExtratoCartao>('Não foi possível obter a SubFrota.',  {sucesso : false, retorno: [], mensagens: []}))
    );
  }
*/



  obterListaRelatorioExtratoCartaoAbastecimento(): Observable<IRelatorioExtratoCartao>{
    //const url = environment.host_ctf_service+ environment.API_ListaRelatorioExtratoCartaoAbastecimento;
    const url = 'http://localhost:3000/listaRelatorioExtratoCartaoAbastecimento'

     return  this.http.get<IRelatorioExtratoCartao>(url).pipe(
      tap(response => {
        if (response && !response.sucesso) {
            this.snackBar.flashMessage('Não foi possível obter a SubFrota.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IRelatorioExtratoCartao>('Não foi possível obter a SubFrota.',  {sucesso : false, retorno: [], mensagens: []}))
    );
  }

  listVeiculos(filtro: IFiltroSubFrotaModel): Observable<IConsultaVeiculoSubFrotaModel> {

    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ListaVeiculosSubFrota;

    return this.http.post<IConsultaVeiculoSubFrotaModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar os veículos da SubFrota.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IConsultaVeiculoSubFrotaModel>('Não foi possível consultar os veículos da SubFrota.', {sucesso : false, retorno: [], mensagens: []}))
    );
  }

  private handleError<T>(mensagem = 'Não foi possível realizar a operação.', result?: T) {
    return (error: any): Observable<T> => {

      this.snackBar.flashMessage(mensagem, ['snackbar-error'], 'Fechar', 0);

      return of(result as T);
    };
  }





  obterListaAbastecimentosDaFrota(filtro: FiltroAbastecimentosViewModel): Observable<IAbastecimentosViewModel>{
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ListarAbastecimentosEditaveis;

    return this.http.post<IAbastecimentosViewModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar os abastecimetos da Frota.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IAbastecimentosViewModel>('Não foi possível consultar os abastecimetos da Frota.', {sucesso : false, retorno: [], mensagens: []}))
    );

  }



  salvarAbastecimentoEditado(editado: AbastecimentoPutModel): Observable<IAbastecimentoEditadoResponse> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_SalvarAbastecimentoEditado;

    console.log(editado)


    return  this.http.put<IAbastecimentoEditadoResponse>(url, editado).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível obter a SubFrota.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IAbastecimentoEditadoResponse>('Não foi possível obter a SubFrota.', {sucesso : false, mensagens: [], retorno: undefined }))
    );
  }

  obterListaAbastecimentosEditadosDaFrota(filtro: FiltroAbastecimentosViewModel): Observable<IAbastecimentosViewModel>{

    /*
    var abastecimentos: IAbastecimentosViewModel = {
      sucesso: true,
      retorno: [
        {
          flgEditavel: true,
          codAbastecimento: 1,
          datAbastecimento: '01/01/2021',
          datDebito: '01/01/2021',
          datCredito: '01/01/2021',
          codFrota: 1,
          papnreduz: 'papnreduz',
          codPosto: 1,
          nomFantasiaPosto: 'nomFantasiaPosto',
          codRede: 1,
          dscPlaca: 'dscPlaca',
          numProduto: 1,
          qtdVolume: 1,
          vlrUnitario: 1,
          vlrUnitarioDesconto: 1,
          vlrTotal: 1,
          vlrTarifaCtf: 1,
          indCombustivel: 'indCombustivel',
          numKm: 1,
          codStatus: 1,
          pacCard: 'pacCard',
          pacOnline: 'pacOnline',
          pa7Intern: 'pa7Intern',
          dscTipoProduto: 'dscTipoProduto',
          numChamado: 'numChamado',
          observacao: 'observacao'
        },
        {
          flgEditavel: true,
          codAbastecimento: 2,
          datAbastecimento: '02/02/2021',
          datDebito: '02/02/2021',
          datCredito: '02/02/2021',
          codFrota: 2,
          papnreduz: 'papnreduz',
          codPosto: 2,
          nomFantasiaPosto: 'nomFantasiaPosto',
          codRede: 2,
          dscPlaca: 'dscPlaca',
          numProduto: 2,
          qtdVolume: 2,
          vlrUnitario: 2,
          vlrUnitarioDesconto: 2,
          vlrTotal: 2,
          vlrTarifaCtf: 2,
          indCombustivel: 'indCombustivel',
          numKm: 2,
          codStatus: 2,
          pacCard: 'pacCard',
          pacOnline: 'pacOnline',
          pa7Intern: 'pa7Intern',
          dscTipoProduto: 'dscTipoProduto',
          numChamado: 'numChamado',
          observacao: 'observacao'
        },
        {
          flgEditavel: true,
          codAbastecimento: 3,
          datAbastecimento: '03/03/2021',
          datDebito: '03/03/2021',
          datCredito: '03/03/2021',
          codFrota: 3,
          papnreduz: 'papnreduz',
          codPosto: 3,
          nomFantasiaPosto: 'nomFantasiaPosto',
          codRede: 3,
          dscPlaca: 'dscPlaca',
          numProduto: 3,
          qtdVolume: 3,
          vlrUnitario: 3,
          vlrUnitarioDesconto: 3,
          vlrTotal: 3,
          vlrTarifaCtf: 3,
          indCombustivel: 'indCombustivel',
          numKm: 3,
          codStatus: 3,
          pacCard: 'pacCard',
          pacOnline: 'pacOnline',
          pa7Intern: 'pa7Intern',
          dscTipoProduto: 'dscTipoProduto',
          numChamado: 'numChamado',
          observacao: 'observacao'
          
        }

      ],
        
      mensagens: []
    };

    return of(abastecimentos);

    */

    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ListarAbastecimentosEditados;

    return this.http.post<IAbastecimentosViewModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar os abastecimetos da Frota.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IAbastecimentosViewModel>('Não foi possível consultar os abastecimetos da Frota.', {sucesso : false, retorno: [], mensagens: []}))
    );

  }

  aprovarAbastecimentoEditado(abastecimento: AprovacaoCorrecaoKm): Observable<AprovacaoCorrecaoKmResult>{
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_SalvarAbastecimentoEditadoAprovado;

    return this.http.put<AprovacaoCorrecaoKmResult>(url, abastecimento, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage(`Não foi possível salvar o abastecimeto: ${abastecimento.codAbastecimento}.`, ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<AprovacaoCorrecaoKmResult>(`Não foi possível salvar o abastecimeto: ${abastecimento.codAbastecimento}.`, {sucesso : false, retorno: false, mensagens: []}))
    );

  }

}


